module.exports = {
  "_type": "graph",
  "graph": {
    "attrs": {},
    "coords": {},
    "data_vars": {
      "nodes_at_link": {
      "attrs": {},
      "data": [
        [
          0,
          1
        ],
        [
          1,
          2
        ],
        [
          2,
          3
        ],
        [
          0,
          4
        ],
        [
          1,
          5
        ],
        [
          2,
          6
        ],
        [
          3,
          7
        ],
        [
          4,
          5
        ],
        [
          5,
          6
        ],
        [
          6,
          7
        ],
        [
          4,
          8
        ],
        [
          5,
          9
        ],
        [
          6,
          10
        ],
        [
          7,
          11
        ],
        [
          8,
          9
        ],
        [
          9,
          10
        ],
        [
          10,
          11
        ]
      ],
      "dims": [
        "link",
        "nodes_per_link"
      ]
    },
    "nodes_at_patch": {
      "attrs": {},
      "data": [
        [
          5,
          4,
          0,
          1
        ],
        [
          6,
          5,
          1,
          2
        ],
        [
          7,
          6,
          2,
          3
        ],
        [
          9,
          8,
          4,
          5
        ],
        [
          10,
          9,
          5,
          6
        ],
        [
          11,
          10,
          6,
          7
        ]
      ],
      "dims": [
        "patch",
        "nodes_per_patch"
      ]
    },
      "x_of_node": {
        "attrs": {},
        "data": [
          0,
          10,
          20,
          30,
          0,
          10,
          20,
          30,
          0,
          10,
          20,
          30
        ],
        "dims": [
          "node"
        ]
      },
      "y_of_node": {
        "attrs": {},
        "data": [
          0,
          0,
          0,
          0,
          10,
          10,
          10,
          10,
          20,
          20,
          20,
          20
        ],
        "dims": [
          "node"
        ]
      }
    },
    "dims": {
      "link": 17,
      "node": 12,
      "nodes_per_link": 2,
      "nodes_per_patch": 4,
      "patch": 6
    }
  },
  "href": "/graph/raster?shape=3%2C4&spacing=10.%2C10."
}
;